import apiClient from '../apiClient';
import { POST_IMAGE_RESTAURANT_ITEM_IMAGE_URL } from '../apiUrl';

const postUploadImageRestaurantItemApi = (Id, data) => {
  return apiClient.post(POST_IMAGE_RESTAURANT_ITEM_IMAGE_URL(Id), data);
};

export default postUploadImageRestaurantItemApi;
